// Auto-generated by the generator
// Don't manually edit this file

// @flow

import {signIn} from './signIn'
import {setReady} from './setReady'
import {setUser} from './setUser'
import {setError} from './setError'
import {setLoading} from './setLoading'

export const sessionActions = {
  signIn,
  setReady,
  setUser,
  setError,
  setLoading,
}
